import React, { useRef, useState } from "react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { motion } from "framer-motion";
import miwereMers from "../images/miweremers.png";
import { SearchContext } from "./Contexts/Context";
import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { createCard } from "../service/service";

function MiwereMers() {
  const [fileName, setFileName] = useState("");
  const { language } = useContext(SearchContext);
  const fileInputRef = useRef(null);

  const handleFileClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("full_name", event.target.name.value);
    formData.append("id_number", event.target.personalNumber.value);
    formData.append("email", event.target.email.value);
    formData.append("mobile", event.target.phone.value);
    formData.append("address", event.target.address.value);
    formData.append("message", event.target.message.value);

    const file = event.target.file.files[0];
    if (file) {
      formData.append("file", file);
    }

    await createCard("message-to-mayor", formData)
      .then((data) => {
        if (data.success) {
          Swal.fire({
            title: "წარმატებით გაიგზავნა",
            icon: "success",
            confirmButtonText: "კარგი",
          });
        }
        event.target.reset();
      })
      .catch((error) => {
        console.error("Error creating petition:", error);
      });
  };

  return (
    <motion.div
      intial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Helmet>
        <title>{language == 1 ? "პეტიციის დამატება" : "Add Petition"}</title>
      </Helmet>

      <div style={{ minHeight: "800px" }}>
        <div className="peticia padding-280px">
          <div className="peticia-left">
            <span className="header">პეტიციის დამატება</span>
            <div className="peticia-inputs">
              <form onSubmit={handleSubmit} className="peticia-inputs">
                <input
                  type="text"
                  name="name"
                  placeholder="სახელი, გვარი"
                  required
                />
                <input
                  type="text"
                  name="personalNumber"
                  placeholder="პირადი ნომერი"
                  maxLength={11}
                  minLength={11}
                  required
                />
                <input
                  type="text"
                  name="email"
                  placeholder="ელ.ფოსტა"
                  required
                />
                <input
                  type="text"
                  name="phone"
                  placeholder="ტელეფონი"
                  required
                />
                <input
                  type="text"
                  name="address"
                  placeholder="ფაქტობრივი მისამართი"
                  required
                />

                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  name="file"
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <label> {fileName ? fileName : "ფაილის ატვირთვა"} </label>
                  <button
                    type="button"
                    onClick={handleFileClick}
                    className="file-upload-button"
                    onChange={handleFileChange}
                  >
                    არჩევა
                  </button>
                </div>
                <textarea
                  name="message"
                  id=""
                  cols="30"
                  rows="10"
                  placeholder="შეტყობინება"
                ></textarea>
                <button type="submit" className="peticia-submit">
                  გაგზავნა
                </button>
              </form>
            </div>
          </div>
          <div className="peticia-right">
            <span className="header">
              {" "}
              <img src={miwereMers} alt="" />
            </span>
            <p>
              ხულოს მუნიციპალიტეტის საკრებულო +995 577 52 97 14 ტბელ აბუსერისძის
              ქუჩა,N1 . დაბა ხულო,აჭარა, საქართველო
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default MiwereMers;
